import { environmentHttpClient as httpClient } from "client/Api/httpClient";
import { Guid } from "client_legacy/ndaw/guid";
import { UsersAndUserGroupsDataModel } from "../UserGroupsManagement/userGroupsManagement";
import { PermissionsUnionModel } from "../common";

export type SettingsViewModel = {
	whoHasAccess: PermissionsUnionModel;
};

export type SettingsSaveModel = {
	whoHasAccess: PermissionsUnionModel;
};

export type AiAssistantSettingsPageModel = {
	kellyHelpsUrl: string;
	kellyTenantId: Guid | null;
	settings: OptionalModel<SettingsViewModel>;
	usersAndUserGroupsData: UsersAndUserGroupsDataModel;
};

export type AiAssistantSettingsSaveModel = {
	settings: OptionalModel<SettingsSaveModel>;
};

export type SubscriptionModel = {
	monthlyPriceEur: number;
};

export type CreditBucketModel = {
	total: number;
	used: number;
};

export type ExtraCreditsModel = {
	used: number;
	creditPriceEur: number;
	costEur: number;
};

export type AiAssistantUsageModel = {
	subscription: SubscriptionModel;
	subscriptionCredits: CreditBucketModel;
	freeCredits: CreditBucketModel;
	extraCredits: ExtraCreditsModel;
};

export enum ProvisionKellyTenantPrerequisite {
	PrimaryEmailAddress = 0
}

export type ProvisionKellyTenantModel = {
	hasAcceptedTerms: boolean;
};

export function getAiAssistantSettings(signal: AbortSignal): Promise<AiAssistantSettingsPageModel> {
	return httpClient.get<AiAssistantSettingsPageModel>(
		"UiApi/AIAssistantSettings",
		undefined,
		{ signal }
	);
}

export function saveAiAssistantSettings(
	model: AiAssistantSettingsSaveModel,
	signal: AbortSignal
): Promise<void> {
	return httpClient.put<void>(
		"UiApi/AIAssistantSettings",
		model,
		{ signal }
	);
}

export function getAiAssistantUsage(signal: AbortSignal): Promise<AiAssistantUsageModel> {
	return httpClient.get<AiAssistantUsageModel>(
		"UiApi/AIAssistantSettings/Usage",
		undefined,
		{ signal }
	);
}

export function provisionKellyTenant(
	model: ProvisionKellyTenantModel,
	signal: AbortSignal
): Promise<Guid> {
	return httpClient.post<Guid>(
		"UiApi/AIAssistantSettings/Provision",
		model,
		{ signal }
	);
}
